
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



export default function CannotDeleteSetWordDialog(props) {

    const { open, handleOk } = props;

    return (

    <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleOk}>
        <DialogTitle id="alert-dialog-slide-title">Cannot delete</DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
            You must unset a word before deleting!
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleOk} >
                Ok
            </Button>


        </DialogActions>
        </Dialog>

    );
}